// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-avenue -> repli-sandbox-avenue-avenue -> metrowest
// Generated: 2026-10-05T18:29:39.599Z
// Counts: 1 design, 20 content, 7 slot group, 2 collection binding, 6 section, 0 style

export const designOverrides = {
  "design._site.font.heading": {
    "cssVariable": "--vibe-font-heading",
    "overrideType": "VALUE",
    "value": "'Montserrat', sans-serif",
    "mappedField": null
  }
};

export const contentOverrides = {
  "amenitieslist.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form.bedroom_list_type": {
    "overrideType": "VALUE",
    "customValue": "derived",
    "generatedValue": null,
    "mappedField": null
  },
  "fees.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "footer.address": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_full_address"
  },
  "footer.copyright": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_copyright"
  },
  "gallery.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "gallery.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "pagehero.subtitle": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_interactivemap_blurb"
  },
  "pagehero.title": {
    "overrideType": "VALUE",
    "customValue": "virtual tour",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "_head.favicon_url": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_fav_icon"
  },
  "apartment-sync-loader.javascript_id": {
    "overrideType": "VALUE",
    "customValue": "eyJpdiI6Ii9Kd2NNSDNQYXpiWjViN1VRZlFFTXc9PSIsInZhbHVlIjoiUUphYXVqY2pYcTZRTTVrWHJ1SWlXUT09IiwibWFjIjoiNmUwZjFkNDVkODQ1MTkxMGFiNzExMDRhNWMwMmEyMjM3YzcxZTBjMzVhOTU3MzAxYjE1ZmNmNTYyMzJmZDJlNCJ9",
    "generatedValue": null,
    "mappedField": null
  },
  "apartment-sync.javascript_id": {
    "overrideType": "VALUE",
    "customValue": "eyJpdiI6Ii9Kd2NNSDNQYXpiWjViN1VRZlFFTXc9PSIsInZhbHVlIjoiUUphYXVqY2pYcTZRTTVrWHJ1SWlXUT09IiwibWFjIjoiNmUwZjFkNDVkODQ1MTkxMGFiNzExMDRhNWMwMmEyMjM3YzcxZTBjMzVhOTU3MzAxYjE1ZmNmNTYyMzJmZDJlNCJ9",
    "generatedValue": null,
    "mappedField": null
  },
  "elise-schedule-tour-iframe.height": {
    "overrideType": "VALUE",
    "customValue": "1700",
    "generatedValue": null,
    "mappedField": null
  },
  "elise-schedule-tour-iframe.hide_scroll_bars": {
    "overrideType": "VALUE",
    "customValue": "false",
    "generatedValue": null,
    "mappedField": null
  },
  "elise-schedule-tour-iframe.url": {
    "overrideType": "VALUE",
    "customValue": "https://app.meetelise.com/8394accb-7205-406d-b60c-955aa4427a80/72ae26ae-2975-11f1-87be-636075e41c25/tour",
    "generatedValue": null,
    "mappedField": null
  },
  "knock-chatbot.api_token": {
    "overrideType": "VALUE",
    "customValue": "c0c85c72a64e11edbd41023423a61a29",
    "generatedValue": null,
    "mappedField": null
  },
  "knock-chatbot.community_id": {
    "overrideType": "VALUE",
    "customValue": "1c9d1afa5011ed51",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "footer.design_by_logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/company/5767906449162415/019d6d9d-49a5-7587-b84e-e2aedab919be.webp"
      }
    }
  },
  "footer.logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_primary_logo"
      }
    }
  },
  "footer.powered_by_logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/company/5767906449162415/019d6d9d-fa1c-74bf-a89d-68fd979db7af.webp"
      }
    }
  },
  "header.schedule_tour_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/schedule-a-tour"
      }
    }
  },
  "pagehero.bg_image": {
    "sourceIndex": 5,
    "fieldOverrides": null
  },
  "ctasection.card3_image": {
    "sourceIndex": 3,
    "fieldOverrides": null
  },
  "hero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162854/019d4489-5af5-740d-88d3-5059ffba93c9.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "City West Apartment Homes leasing center entrance with balloons and palm trees."
      }
    }
  }
};

export const collectionBindingOverrides = {
  "amenitieslist.apartmentItems": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "gallery.images": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "apartment-sync-loader",
      "blockId": "apartment-sync-loader",
      "position": 0
    },
    {
      "sectionId": "knock-chatbot",
      "blockId": "knock-chatbot",
      "position": 0
    }
  ],
  "floor-plans": [
    {
      "sectionId": "apartment-sync",
      "blockId": "apartment-sync",
      "position": 7
    }
  ],
  "schedule-a-tour": [
    {
      "sectionId": "elise-schedule-tour-iframe",
      "blockId": "elise-schedule-tour-iframe",
      "position": 7
    }
  ]
};

export const styleOverrides = {};
